<template>
  <transition name="slide-fade">
    <div class="float-menu" v-show="open === false">
      <div class="inside-closer" v-on:click="$store.commit('changeShowMenu', false)">✖</div>
        <div class="outside">
          <div class='info-button' v-if="user !== null" v-on:click="$store.commit('showInfoMenu', true)"> &#x2630</div>
          <!--<router-link to="/map" class="menu-map float-item"></router-link>-->
          <router-link to="/votev" class="menu-battle float-item"><div class='info-text'>Rösta</div></router-link>
          <router-link to="/profile" class="menu-profile float-item"><div class='info-text'>Profil</div></router-link>
          <!--<router-link v-if="user === null" to="/profile" class="menu-text float-item">LOGIN</router-link>-->
          <router-link to="/ar" class="menu-ar float-item" v-on:click.native="closeMenu"><div class='info-text'>Glasögon</div></router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'floatMenu',
  data () {
    return {
      open: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    closeMenu () {
      this.open === true
    }
  },
  mounted () {
  },
  beforeDestroy () {
    this.$store.commit('changeShowMenu', false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-button {
  background-color: #2f4efd;
  color: #fff;
  position: fixed;
  top: 22px;
  right: 24px;
  border-radius: 36px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
}
  .float-menu {
    position: fixed;
    bottom: 0px;
    left: 0;
    top: 0px;
    right: 0px;
    z-index: 99;
    line-height: 70px;
    background: linear-gradient(0, #fff 5%, transparent);
    border: 0px solid #F0F0F0;
    -webkit-user-select: none;  /* Chrome all / Safari all */
    -moz-user-select: none;     /* Firefox all */
    -ms-user-select: none;      /* IE 10+ */
    user-select: none;          /* Likely future */  
  }
  .outside {
    width: 100vw;
    height: 100vh;
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    color: #fff;
  }
  .float-item {
    position: absolute;
    height: 66px;
    width: 66px;
    bottom: 0;
    border-radius: 66px;
    background-color: #e6e6e6;
    background-size: 33px;
    background-repeat: no-repeat;
    background-position: center center;
    vertical-align: middle;
    border: 1px solid #d8d8d8;
    -webkit-transition: all 2s; /* Safari 3.1 to 6.0 */
    transition: all 2s;
  }
  .float-item .info-text {
    position: relative;
    bottom: -73px;
    line-height: 12px;
    font-size: 10px;
    font-weight: bold;
    color: #272264;
    text-transform: uppercase;
    margin: auto;
  }
  .menu-ar.float-item {
    animation: 0.3s ease-in 0s 1 slideInFromLeft;
    left: calc(50% - 130px);
    bottom: 90px;
  }
  .menu-profile.float-item { 
    animation: 0.25s ease-in 0s 1 slideInFromLeft; 
    bottom: 120px;
    left: calc(50% - 33px); 
  }
  .menu-battle.float-item { 
    animation: 0.3s ease-in 0s 1 slideInFromLeft; 
    bottom: 90px;
    left: calc(50% + 130px - 66px); 
  }
  @keyframes slideInFromLeft {
    0% {
      opacity: 0px;
      bottom: 70px;
      left: 50%;
      height: 10px;
      width: 10px;
      transform: perspective(500px) translateZ(-100px);
    }
    100% {
      opacity: 1;
      transform: perspective(500px) translateZ(0px);
    }
  }
  a.menu-map {
    background-image: url('./../assets/map_off.svg');
  }
  a.menu-map:hover, a.menu-map.router-link-active {
    background-image: url('./../assets/map_on.svg');
  }
  a.menu-ar {
    background-size: 60px;
    background-image: url('./../assets/float/ar.svg');
  }
  a.menu-ar:hover, a.menu-ar.router-link-active { 
  }
  a.menu-profile {
    background-size: 50px;
    background-image: url('./../assets/float/profile.svg');
  }
  a.menu-profile:hover, a.menu-profile.router-link-active {
  }
  a.menu-battle {
    background-size: 36px;
    background-image: url('./../assets/float/battle.svg');
  }
  a.menu-battle:hover, a.menu-battle.router-link-active { }

  @-webkit-keyframes clickAnimation {
    from {
      -webkit-transform: scale(1.3);
    }
    to {
      -webkit-transform: scale(1);
    }
  }
  .menu-text {
    text-transform: uppercase;
    font-size: 15px;
    letter-spacing: 2px;
    color: grey;
  }


</style>



// WEBPACK FOOTER //
// FloatMenu.vue?530031fb